import { render } from "./CardComp.vue?vue&type=template&id=5c70f865"
import script from "./CardComp.vue?vue&type=script&lang=js"
export * from "./CardComp.vue?vue&type=script&lang=js"

import "./CardComp.vue?vue&type=style&index=0&id=5c70f865&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__